// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".avatar[data-v-c19e76ae]{width:200px;height:200px;border-radius:50%}", ""]);
// Exports
module.exports = exports;
